import { LayoutWithSidebar, PageLayout_TwoCol_Narrow_Wide } from "@swivl-mono/ui";
import { useEffect } from "react";
import { Link, Outlet } from "react-router-dom";

import { SidebarLink } from "../../Components/SidebarLink/SidebarLink";
import { NavBar } from "../../Models/NavBar/NavBar.Model";

export function AdminView() {
  useEffect(() => {
    NavBar.set(<NavBar.Component.Title title="Admin" />, null, null, "Admin");
  }, []);

  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col">
          <SidebarLink to="/admin/embed">Embed Tester</SidebarLink>
          <SidebarLink to="/admin/widget">Widget Tester</SidebarLink>
          <SidebarLink to="/admin/feature-flags">Feature Flags</SidebarLink>
          <SidebarLink to="/admin/fms-capabilities">FMS Capabilities</SidebarLink>
          <SidebarLink to="/admin/server-debug">Server Debug</SidebarLink>
          <SidebarLink to="/admin/test-caller">Test Caller</SidebarLink>
          <SidebarLink to="/admin/sequence-test-run">Sequence Test Run</SidebarLink>
          <SidebarLink to="/admin/outbound-allowlist">Outbound Allowlist</SidebarLink>
          <SidebarLink to="/admin/variables">Variables</SidebarLink>
          <SidebarLink to="/admin/analytics">Analytics Playground</SidebarLink>
          <SidebarLink to="/admin/onboarding">Onboarding</SidebarLink>
          <SidebarLink to="/admin/billing">Billing</SidebarLink>
          <SidebarLink to="/admin/nlp-caches">NLP Caches</SidebarLink>
          <SidebarLink to="/admin/nlp-comparison">NLP Comparison</SidebarLink>
          <SidebarLink to="/admin/cortex-v3-migrate">Migrate to Cortex V3</SidebarLink>
          <SidebarLink to="/admin/policy-notifications">Policy Notifications</SidebarLink>
        </div>
      }
      contentNoPadding={true}
      content={<Outlet />}
    />
  );
}
